import { memo } from "react";

import classNames from "classnames";
import { findIndexBy } from "neetocist";
import { globalProps } from "neetocommons/initializers";
import { Tooltip, Typography } from "neetoui";
import { collectBy, eqProps, pathEq, pluck, prop } from "ramda";
import { useTranslation } from "react-i18next";

import EmojiPicker from "components/EmojiPicker";

const findOwnIndex = findIndexBy({ userId: globalProps.user.id });
const groupReactions = collectBy(prop("unified"));

const Reactions = ({ reactions, onAdd, onRemove }) => {
  const { t } = useTranslation();
  const groups = groupReactions(reactions);

  const onSelect = emoji => {
    // Try to find group to which emoji belongs in existing reactions.
    const group = groups.find(pathEq(emoji.unified, [0, "unified"]));
    if (group && findOwnIndex(group) >= 0) return; // User already reacted with same emoji.
    onAdd({ ...emoji, emoji: emoji.native });
  };

  return (
    <div className="mt-2 flex flex-wrap gap-0.5">
      <div className="neeto-ui-rounded-full neeto-ui-bg-gray-200 me-2">
        <EmojiPicker {...{ onSelect }} />
      </div>
      {groups.map(reactions => {
        const ownIndex = findOwnIndex(reactions);
        const selected = ownIndex >= 0;
        const reaction = selected ? reactions[ownIndex] : reactions[0];
        const names = pluck("reactor", reactions).join(", ");

        return (
          <Tooltip
            key={reaction.unified}
            position="top"
            content={
              <p className="text-center text-xs">
                {t("neetoMolecules.engagements.namesReacted", { names })}
              </p>
            }
          >
            <div
              className={classNames(
                "neeto-ui-rounded-full mx-1 flex cursor-pointer items-center justify-center px-2 py-1",
                {
                  "neeto-ui-bg-accent-100": selected,
                  "neeto-ui-bg-gray-100": !selected,
                }
              )}
              onClick={() => (selected ? onRemove : onAdd)(reaction)}
            >
              <Typography
                className="flex items-center gap-x-1 text-sm"
                style="body2"
              >
                <span className="text-sm">{reaction.emoji}</span>
                <span className="text-sm">{reactions.length}</span>
              </Typography>
            </div>
          </Tooltip>
        );
      })}
    </div>
  );
};

export default memo(Reactions, eqProps("reactions"));
